import React from "react";
import {IJobDefinitionStep, Processor, StartMode} from "../../models/JobDefinitionStep";
import {DataGrid} from "@mui/x-data-grid";
import {Button, Typography} from "@mui/material";
import {Add} from "@mui/icons-material";

interface IJobDefinitionStepsTableProps {
	steps: IJobDefinitionStep[];
	deletedSteps: IJobDefinitionStep[];
	setDeletedSteps: (steps: IJobDefinitionStep[]) =>  void;
	setSteps: (steps: IJobDefinitionStep[]) =>  void;
	setActiveRow: (id: number) => void;
}

export const JobDefinitionStepsTable: React.FC<IJobDefinitionStepsTableProps> = (props) => {
	const addNewStep = () => {
		let maxId = Math.max(...props.steps.map(it => it.id)) > 999999 ? Math.max(...props.steps.map(it => it.id)) : 1000000;
		props.setSteps([...props.steps, {id: ++maxId, jobSettings: undefined, inputStep: undefined, description: "", order: 0, concurrency: 0, processor: Processor.CsvCreator, startMode: StartMode.Manual}]);
		props.setActiveRow(maxId);
	};
	
	const deleteStep = (id: number) => {
		if (props.deletedSteps.findIndex(it => it.id === id) === -1) {
			// delete it
			if (id > 999999) {
				props.setSteps([...props.steps.filter(it => it.id !== id)]);
			} else {
				props.setDeletedSteps([...props.deletedSteps, props.steps.filter(it => it.id === id)[0]]);
			}
		} else {
			// // un-delete it
			props.setDeletedSteps([...props.deletedSteps.filter(it => it.id !== id)]);
		}
	};
	
	return (
		<>
			<div style={{height: "100%", display: "flex", justifyContent: "space-around"}}>
				<div style={{width: "80%", maxWidth: "80%"}}>
					<Typography variant={"h5"}>Steps</Typography>
					<Button onClick={() => addNewStep()}><Add /></Button>
					<hr />
					<DataGrid
						autoHeight={true}
						sortModel={[
							{
								field: "order",
								sort: "asc"
							}
						]}
						columns={[
							{
								headerName: "Edit",
								renderCell: (params) => {
									return (
										<>
											<Button
												onClick={() => props.setActiveRow(params.row.id)}
											>
												Edit
											</Button>
										</>
									);
								},
								field: "none"
							},
							{
								headerName: "Delete",
								renderCell: (params) => {
									return (
										<>
											<Button
												color="error"
												onClick={() => deleteStep(params.row.id)}
											>
												Delete
											</Button>
										</>
									);
								},
								field: "none1"
							},
							{
								field: "order",
								width: 200,
							},
							
							{
								field: "description",
								width: 200,
								renderCell: (params) => <span style={{textDecoration: (props.deletedSteps.findIndex(it => it.id === params.row.id)) !== -1 ? "line-through" : "none",}}>{params.value}</span>
							},
						]}
						rows={props.steps}
					/>
				</div>
			</div>
		</>
	);
};
